import { isValidPhoneNumber } from 'libphonenumber-js/mobile';
import { addMethod, string, StringSchema } from 'yup';
import * as cardValidator from 'card-validator';

import { validationLang } from './common';

export const email = string()
  .trim()
  .email(validationLang.email)
  .max(64)
  .required();

const MUST_HAVE_LETTER_REGEXP = /[a-zA-Z]/;
const MUST_HAVE_NUMBER_REGEXP = /\d/;
const MUST_NOT_HAVE_SPACE_REGEXP = /^\S*$/;

// TODO: may should we add exported const for test names?
export const password = string()
  .trim()
  .min(8)
  .max(64)
  .matches(MUST_HAVE_LETTER_REGEXP, {
    message: validationLang.shouldContainLetter,
    name: 'mustHaveLetter',
  })
  .matches(MUST_NOT_HAVE_SPACE_REGEXP, {
    message: validationLang.shouldNotContainSpace,
    name: 'mustNotHaveSpace',
  })
  .matches(MUST_HAVE_NUMBER_REGEXP, {
    message: validationLang.shouldContainNumber,
    name: 'mustHaveNumber',
  })
  .required();

export const URL_REGEX =
  // eslint-disable-next-line max-len, no-useless-escape
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

export const url = string()
  .trim()
  .lowercase()
  .matches(URL_REGEX, validationLang.url);

addMethod<StringSchema>(string, 'phoneNumber', function () {
  return this.test((value, context) => {
    if (!value) {
      return true;
    }
    return (
      // TODO: replace by BE validation
      isValidPhoneNumber(value) ||
      context.createError({ message: validationLang.phoneNumber })
    );
  });
});

addMethod<StringSchema>(string, 'creditCardNumber', function () {
  return this.test((value, context) => {
    if (!value) {
      return true;
    }
    return (
      cardValidator.number(value).isValid ||
      context.createError({
        message: validationLang.creditCardNumber,
      })
    );
  });
});

addMethod<StringSchema>(
  string,
  'creditCardExpirationDate',
  function () {
    return this.test((value, context) => {
      if (!value) {
        return true;
      }
      return (
        cardValidator.expirationDate(value).isValid ||
        context.createError({
          message: validationLang.creditCardExpirationDate,
        })
      );
    });
  },
);

addMethod<StringSchema>(string, 'creditCardCvc', function () {
  return this.test((value, context) => {
    if (!value) {
      return true;
    }
    return (
      cardValidator.cvv(value, [3, 4]).isValid ||
      context.createError({ message: validationLang.creditCardCvc })
    );
  });
});

declare module 'yup' {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface StringSchema {
    phoneNumber(): this;
    creditCardNumber(): this;
    creditCardExpirationDate(): this;
    creditCardCvc(): this;
  }
}
